import { type InitFlowComponent, useIntl } from '@capsicum/common';
import { InitAppPage } from '@capsicum/common-web';
import { useForcedRequirementsCheckerFlow } from '@capsicum/features/regulations/shared';

import { ForcedRequirementsHandler } from '../ui/requirement-handlers/ForcedRequirementsHandler';

/**
 * Check if there are forced Requirements to be accepted
 */
export const ForcedRequirementsCheckerFlow: InitFlowComponent = ({ fallback, next }) => {
	const { $t } = useIntl();

	const { areCredentialsFetching, firstForcedRequirement, shouldShowForcedRequirements } =
		useForcedRequirementsCheckerFlow(next);

	if (shouldShowForcedRequirements && firstForcedRequirement) {
		return (
			<InitAppPage
				body={
					!areCredentialsFetching ? (
						<ForcedRequirementsHandler requirementIdentifier={firstForcedRequirement} />
					) : (
						<></>
					)
				}
				testID="forced-requirements-handler-top-bar"
				title={$t('jurisdictionRequirements.verification')}
			/>
		);
	}

	return fallback;
};

ForcedRequirementsCheckerFlow.keepAlive = true;
